module.exports = __webpack_public_path__ + "static/custom-marker-shapes-fe6b303a2a4599cfc636c8fb1ebc1898.png";